import consumer from "./consumer"

consumer.subscriptions.create("TurboStreamsChannel", {
  connected() {
    console.log("Connected to TurboStreamsChannel")
  },

  disconnected() {
    console.log("Disconnected from TurboStreamsChannel")
  },

  received(data) {
    console.log("Received data from TurboStreamsChannel", data)
  }
})

// This allows us to subscribe to specific streams
// Example usage in an ERB template:
// <%= turbo_stream_from "article_comments_#{@article.id}" %>
// 
// Which lets the client receive broadcasts to that stream